import logError from '@/utils/logError/logError';
import businessService from '../services/businessService';

const state = {
  smsBalance: null,
  smsAutoReload: null,
};

const actions = {
  async loadSmsBalance({ commit }, businessId) {
    try {
      const balance = await businessService.fetchSmsBalance(businessId);
      if (balance !== null && typeof balance === 'object') {
        commit('setSmsBalance', balance.data);
      }
    } catch (error) {
      logError('There was an error retrieving SMS balance', error);
      commit('setSmsBalance', null);
    }
  },

  async loadSmsAutoReload({ commit, state: currentState }, { businessId, force = false }) {
    if (currentState.smsAutoReload !== null && !force) {
      return;
    }

    try {
      const response = await businessService.fetchSmsAutoReload(businessId);
      commit('setSmsAutoReload', response?.data?.auto_reload === true);
    } catch (error) {
      logError('There was an error retrieving the SMS auto reload setting', error);
    }
  },

  async updateSmsAutoReload({ commit, state: currentState }, { businessId, enabled }) {
    const previous = currentState.smsAutoReload;
    commit('setSmsAutoReload', enabled);

    try {
      const response = await businessService.updateSmsAutoReload(businessId, enabled);
      commit('setSmsAutoReload', response?.data?.auto_reload === true);
    } catch (error) {
      commit('setSmsAutoReload', previous);
      throw error;
    }
  },
};

const mutations = {
  setSmsBalance(state, balance) {
    state.smsBalance = balance;
  },
  setSmsAutoReload(state, enabled) {
    state.smsAutoReload = enabled;
  },
};

const getters = {
  smsBalance: (state) => state.smsBalance,
  smsAutoReload: (state) => state.smsAutoReload === true,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
